export default "__VITE_ASSET__ed95188b__"